export class addSemsubjectModelH {
    Subject:string;
    CourseSemesterExamId:number;
}




// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/subject/addSemsubject.model.ts